'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var irefImg = require('./assets/iref.png');

var ProjectIrefImage = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(ProjectIrefImage, _PureComponent);

  function ProjectIrefImage() {
    (0, _classCallCheck3.default)(this, ProjectIrefImage);
    return (0, _possibleConstructorReturn3.default)(this, (ProjectIrefImage.__proto__ || (0, _getPrototypeOf2.default)(ProjectIrefImage)).apply(this, arguments));
  }

  (0, _createClass3.default)(ProjectIrefImage, [{
    key: 'render',
    value: function render() {
      var className = this.props.className;


      return _react2.default.createElement('img', {
        className: (0, _bind2.default)(className),
        src: irefImg,
        alt: ''
      });
    }
  }]);
  return ProjectIrefImage;
}(_react.PureComponent), _class.propTypes = {
  className: _propTypes2.default.string
}, _temp);
exports.default = ProjectIrefImage;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectIrefImage/ProjectIrefImage.js
// module id = 832
// module chunks = 1